document.addEventListener("on:cart:add", (event) => {
    let cart = event.detail.cart;
    let product = cart.items[cart.items.length - 1]; // Get last added product

    if (product) {
        showPopup(product);
    }
});


function showPopup(product) {
    let popupHTML = `
        <div class="popup-overlay">
            <div class="popup-content">
                <div class="popup-header">
                    <span>✔ Success! Your item has been added to the cart.</span>
                    <button class="popup-close" onclick="closePopup()">×</button>
                </div>
                <div class="popup-body">
                    <img src="${product.image}" alt="${product.product_title}">
                    <div>
                        <p><strong>${product.product_title}</strong></p>
                        <p>QTY: ${product.quantity} | <strong>${formatPrice(product.price)}</strong></p>
                    </div>
                </div>
                <div class="popup-footer">
                    <button onclick="closePopup()">Continue Shopping</button>
                    <button onclick="window.location.href='/cart'">View Cart</button>
                </div>
            </div>
        </div>`;
    
    document.body.insertAdjacentHTML("beforeend", popupHTML);
}

function closePopup() {
    document.querySelector(".popup-overlay").remove();
}

function formatPrice(price) {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(price / 100);
}
